import React from 'react';
import Button from '@arrive/button';

import styles from './TimezoneError.scss';

export default function TimezoneError() {
  return (
    <div className={styles.container}>
      <h1>Timezone Discrepancy</h1>

      <p>
       Your machine’s timezone and time may not match, which is preventing you from accessing our site. You can resolve this by following these instructions.
      </p>

      <div>
        <h2>Windows:</h2>
        <a className={styles.helpLink} target='_blank' rel='noopener noreferrer' href='https://arrivelogistics.atlassian.net/l/c/ZCRhFPZr'>How to sync your time and timezone</a>
      </div>

      <div>
        <h2>Mac:</h2>
        <a className={styles.helpLink} target='_blank' rel='noopener noreferrer' href='https://arrivelogistics.atlassian.net/wiki/spaces/ARRIVE/pages/1459290512/How+to+Set+Your+Computer+Time+and+Timezone#Mac-Computer'>How to sync your time and timezone</a>
      </div>

      <p>
        Once both timezone and clock are synced, <Button className={styles.refreshBtn} text onClick={() => window.location.reload()}>refresh</Button> your browser
      </p>

      <p>
          If none of the suggestions provide a fix, please <a className={styles.helpLink} target='_blank' rel='noopener noreferrer' href='https://arrivelogistics.atlassian.net/servicedesk/customer/portal/5/group/10/create/112'>contact us</a>. Useful information to include in your message:
      </p>
      <ul>
        <li>What browser and operating system you&apos;re using.</li>
        <li>Screenshots of your entire browser window.</li>
        <li>Any steps you took to get you to this screen.</li>
      </ul>
    </div>
  )
}
